import React, { useState } from 'react';
import { users } from '../usersData';
import '../styles/login.css'; 
import logo from '../assets/logo.png';

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const handleLogin = async () => {
        setIsLoggingIn(true); // เริ่มโหลด
        const trimmedUsername = username.trim();
        const trimmedPassword = password.trim();

        const matchedUser = users.find(u => u.username === trimmedUsername && u.password === trimmedPassword);

        if (matchedUser) {
            console.log(`Login Successful for Username: ${matchedUser.username}`);
            await new Promise(resolve => setTimeout(resolve, 500)); // เพิ่ม delay เล็กน้อยเพื่อความต่อเนื่อง
            onLogin({ username: matchedUser.username, userRole: matchedUser.role, carNumber: matchedUser.carNumber });
        } else {
            setIsLoggingIn(false);
            alert("รหัสผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
        }
    };

    return (
        <div className="login-background">
            <div className="login-container">
                <img src={logo} alt="ลุงรวย" className="login-logo" />
                <h2>เข้าสู่ระบบ</h2>
                <input
                    type="text"
                    placeholder="ชื่อผู้ใช้"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={isLoggingIn}
                />
                <input
                    type="password"
                    placeholder="รหัสผ่าน"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoggingIn}
                />
                <button onClick={handleLogin} disabled={isLoggingIn}>
                    {isLoggingIn ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
                </button>
            </div>
        </div>
    );
};

export default Login;
